import { render, staticRenderFns } from "./intelligentRecord.vue?vue&type=template&id=4a504997"
import script from "./intelligentRecord.vue?vue&type=script&lang=js"
export * from "./intelligentRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports